import { createCustomEnum } from "./customEnum";

const TerminalProgramTypes = createCustomEnum({
	Normal: {
		name: "normal",
		value: 0,
		displayName: "Normal",
	},
	RiseFree: {
		name: "RiseFree",
		value: 1,
		displayName: "RISE FREE",
	},
});

export default TerminalProgramTypes;
